import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {IPositionListItemModel} from '../../core/interfaces/position-list-item.interface';
import {PositionService} from '../../core/position.service';
import {AttachmentService} from '../../core/attachment.service';
import { switchMap, tap, map, finalize} from 'rxjs';

import {UploadErrorDialogComponent} from '../../shared/upload-error-dialog/upload-error-dialog.component';

@Component({
    selector: 'app-add-job-description-modal',
    templateUrl: './add-job-description-modal.component.html',
    styleUrls: ['./add-job-description-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddJobDescriptionModalComponent implements OnInit {
  @Input() public position: IPositionListItemModel;
  @Output() public onDescriptionAdded = new EventEmitter<any>();
  private _modal: NgbModalRef;

  constructor(public activeModal: NgbActiveModal, private attachmentService: AttachmentService, private modalService: NgbModal, private positionService: PositionService) {  }

  public ngOnInit() {

  }

  public onUploadJobDescriptionFileChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const files = input.files;
  const allowedExtensions = ['pdf', 'doc', 'docx'];

  if (!files?.length) return;

  const file = files[0];
  const ext = file.name.split('.').pop()?.toLowerCase();
  if (!ext || !allowedExtensions.includes(ext)) {
    const modalRef = this.modalService.open(UploadErrorDialogComponent);
    const dlg = modalRef.componentInstance as UploadErrorDialogComponent;
    dlg.title = 'Invalid File Type';
    dlg.body  =
      `The selected file type is not allowed.<br/><br/>
       Please upload a file with one of the following extensions:
       <strong>.pdf, .doc, or .docx</strong>.`;
    dlg.onConfirm.subscribe(() => { input.value = ''; });
    return;
  }

  this.attachmentService.upload(file).pipe(
    tap(attachmentId => this.position.jobDescriptionAttachmentId = attachmentId),
    switchMap(attachmentId =>
      this.positionService.get(this.position.positionId).pipe(
        map(position => ({ position: { ...position, jobDescriptionAttachmentId: attachmentId }, attachmentId }))
      )
    ),
    switchMap(({ position, attachmentId }) =>
      this.positionService.save(position).pipe(
        tap(() => this.onDescriptionAdded.emit({
          positionId: this.position.positionId,
          attachmentId,
          fileName: file.name
        }))
      )
    ),
    finalize(() => { input.value = ''; })
  ).subscribe({
    next: () => { this.activeModal.dismiss(); },
    error: () => {
      const modalRef = this.modalService.open(UploadErrorDialogComponent);
      const dlg = modalRef.componentInstance as UploadErrorDialogComponent;
      dlg.title = 'Error Uploading File';
      dlg.body  =
        `The file you are uploading exceeds the maximum file size.<br/><br/>
         Please contact us at <a href='tel:314-993-8008'>314-993-8008</a> or
         <a href='mailto:testing@leadershipall.com'>testing@leadershipall.com</a>.`;
      dlg.onConfirm.subscribe(() => { input.value = ''; });
    }
  });
}


  public onCancel() {
    this.activeModal.dismiss();
  }
}
